import React from 'react';

const Latvia = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46347)">
      <rect width="28" height="20" rx="3" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 12H28V20H0V12ZM0 0H28V8H0V0Z" fill="#AF010D" />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46347">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Latvia;
